import React from "react";

// Gold floral ornament divider inspired by the logo.
export const Ornament = ({ className = "", width = 220 }) => (
  <div className={`flex items-center justify-center ${className}`} data-testid="ornament-divider">
    <svg width={width} height={(width / 220) * 40} viewBox="0 0 220 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="goldGrad" x1="0" y1="0" x2="220" y2="0" gradientUnits="userSpaceOnUse">
          <stop stopColor="#A6844F" />
          <stop offset="0.5" stopColor="#E4CFA8" />
          <stop offset="1" stopColor="#A6844F" />
        </linearGradient>
      </defs>
      <line x1="0" y1="20" x2="78" y2="20" stroke="url(#goldGrad)" strokeWidth="1" />
      <circle cx="84" cy="20" r="2.5" fill="#C8A97E" />
      <path d="M110 8c-6 6-14 6-20 4 6 4 8 10 8 16-3-5-9-7-15-6 6 2 9 7 10 12 1-5 4-9 9-11-3 6-2 12 2 16-1-6 2-11 7-14-5-1-10-5-11-11 4 3 9 3 13 0-4-2-6-6-5-11 3 4 8 5 12 3-4-3-6-8-4-13-3 5-8 7-13 5 3 2 4 6 3 10z" fill="url(#goldGrad)" opacity="0.9" transform="translate(0,0) scale(0.85)" />
      <circle cx="110" cy="20" r="3.5" fill="#C8A97E" />
      <path d="M132 20c4-4 9-4 13-2-4-2-6-6-5-11 3 4 8 5 12 3-4 3-6 8-4 13" fill="none" stroke="url(#goldGrad)" strokeWidth="1.2" opacity="0.8" />
      <circle cx="136" cy="20" r="2.5" fill="#C8A97E" />
      <line x1="142" y1="20" x2="220" y2="20" stroke="url(#goldGrad)" strokeWidth="1" />
    </svg>
  </div>
);

export default Ornament;
